// removed by extract-text-webpack-plugin
module.exports = {"modal":"_3V89oIwF6DIleI4yhMbZ-b","modalDialog":"_2L2Lc3UR4ze0SakCYS06ou","modalContent":"_2FpHa0D1aEsS8IM-sU4MGy"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/WithModal/style.css
// module id = 298
// module chunks = 0